'use strict';

require('hc-sticky');

const $siteHeader = $('.siteheader');

/**
 * Destroy sticky components
 */
function destroyStickyPLPComponents() {
    $('.js-filter-bar').hcSticky('destroy');
}

/**
 * Update sticky components on PLP for persistent filters
 */
function updateStickyPLPComponents() {
    const animationBuffer = 16; // 16px = 1rem, buffer prevents content from showing between header and filter bar during animation
    const $filterBar = $('.js-filter-bar');
    if ($(window).scrollTop() > 0) {
        const headerPosition = $siteHeader.css('position');
        const topOffset = headerPosition !== 'sticky' && ($filterBar.hasClass('brand-Columbia'))
            ? 0
            : $siteHeader.outerHeight() - animationBuffer;

        // Update top offset
        $filterBar.hcSticky('update', { top: topOffset });
        $filterBar.toggleClass('w-100 left-05rem', $filterBar.css('position') === 'fixed');
    }
}

/**
 * Initialize sticky components on PLP for persistent filters
 */
function initStickyPLPComponents() {
    $('.js-filter-bar').hcSticky({
        stickTo: '.js-plp-sticky-row',
        top: 0
    });

    document.addEventListener('scroll', updateStickyPLPComponents, { passive: true });
    $(window).on('widthResize', updateStickyPLPComponents);
}

module.exports = {
    initStickyPLPComponents: initStickyPLPComponents,
    destroyStickyPLPComponents: destroyStickyPLPComponents
};
